import request from '@/utils/request';
import apiConstants from '@/utils/apiConstants';

const routingService = {
  getStates() {
    return request({
      url: apiConstants.END_POINTS.ROUTING.STATES,
      method: 'get'
    });
  }
};

export default routingService;
